import { planTypes } from '@/common/constants';
import modulesmap from './auto-scan';
import sorts, { getSortedTypes } from './sort';
import { values } from 'lodash';

const planTypeSorts = sorts;

export default planTypes.map(planTypeSorts).map(x => modulesmap[x]);

/**
 * get plans by plan type and plan sub type
 * @param {string} type
 * @param {string} subType
 * @returns
 */
export const getPlans = (type, subType) => {
  const sortedPlanTypes = getSortedTypes(type, subType);
  return planTypes.map(sortedPlanTypes).map((x) => modulesmap[x]);
}

export const AllPlans = values(modulesmap);

export const sortSelectedPlansMethod = (a, b) => {
    const aIndex = planTypeSorts.findIndex(x => x === a.type);
    const bIndex = planTypeSorts.findIndex(x => x === b.type);
    if (aIndex < bIndex) return -1;
    if (aIndex > bIndex) return 1;
    return 0;
};
